<template>
    <div>

    </div>
</template>


<script>
export default {
    name: "pwa_payment_tab",
    props: {
        location: {
            type: Object,
            default: () => ({})
        },
        is_qr: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            countries: [],
            attached_payments : [],
        }
    },

    methods : {
        async loadAttachedPayments() {

            await api.get('/internal/v1/payment/gates/3/splitters/' + this.locationId)
                .then(({data}) => {
                    this.isLoadSplitters = false;

                    if (data.status === 'operation_success') {
                        this.splitters = this.normalizeSplitters(data.data);
                    }
                })
                .catch(({response}) => {
                    this.isLoadSplitters = false;
                });

        },
    },

    computed : {
        locationId() {
            return parseInt(this.location.id);
        },
    }
}
</script>


<style scoped>

</style>
